// extracted by mini-css-extract-plugin
export default {"itemContainer":"itemContainer-OTxBO","icon":"icon-QhaUG","text":"text-cLzfr","dropdown":"dropdown-zUpX7"};